import { Col, DatePicker, Form, Input, notification, Row, Select } from 'antd';
import classNames from 'classnames/bind';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import uploadAPI from '~/api/UploadAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import config from '~/config';
import { genderList } from '~/constants';
import { updateInfoProfile } from '~/store/actions/UserAction';
import { checkKeyDownNumberInput } from '~/utils';
import CardAboutMe from '../../components/card-about-me';
import styles from './EditProfile.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { LeftOutlined } from '@ant-design/icons';

const cx = classNames.bind(styles);

const Gender = styled.div`
    .ant-select.ant-select-in-form-item {
        height: 44px;
    }
    .ant-select-selector {
        height: 44px;
    }
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        height: 44px;
    }
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        height: none;
    }
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        height: 44px;
    }
    .ant-select-selection-placeholder {
        height: 44px;
        align-items: center;
        display: flex;
    }
    .ant-select-selection-item {
        height: 44px;
        align-items: center;
        display: flex;
    }
    .ant-select-selection.ant-select-selection--single {
        height: 44px;
    }

    .ant-select-selection-selected-value {
        height: 44px;
    }
`;

const Birthday = styled.div`
    .ant-picker {
        height: 44px;
        width: 100%;
    }
`;

const ChangeAVT = styled.div`
    #contained-button-file {
        display: none;
    }
`;

const EditProfile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.user.userInfo);
    const [gender, setGender] = useState(userInfo?.gender || null);
    const [birthday, setBirthday] = useState(userInfo?.birthday ? new Date(parseInt(userInfo?.birthday)) : 0);
    const [msgError, setMsgError] = useState('');
    const [avatar, setAvatar] = useState(userInfo?.avatar);

    const [form] = Form.useForm();
    const defaultValues = {
        fullname: userInfo?.fullname,
        phone: userInfo?.phone,
        email: userInfo?.email,
    };
    useEffect(() => {
        form.setFieldsValue(defaultValues);
        // eslint-disable-next-line
    }, [userInfo]);
    const onFinishEdit = (data) => {
        try {
            const date = new Date(birthday);
            const dataEdit = {
                fullname: data.fullname,
                phone: data.phone,
                email: data.email,
                birthday: parseInt(date.getTime()),
                gender: gender,
            };

            dispatch(
                updateInfoProfile(
                    dataEdit,
                    (isSuccess) => {
                        if (isSuccess) {
                            form.setFieldsValue(defaultValues);
                            navigate(config.routes.profile);
                            notification.open({
                                message: 'Information edited successfully',
                                duration: 2,
                                placement: 'top',
                            });
                        } else {
                        }
                    },
                    (err) => {
                        if (err.message) {
                            setMsgError(err.message);
                            console.log('Error', err.message);
                        }
                    },
                ),
            );
        } catch (err) {
            console.log(err);
        }
    };
    const handleChangeGender = (value) => {
        setGender(value);
    };
    const handleChangeBirthday = (value) => {
        setBirthday(value);
    };
    const handleUpload = async (e) => {
        const formData = new FormData();
        formData.append('image', e.target.files[0]);
        try {
            const response = await uploadAPI.avatarAPI(formData);
            if (response.code === 200) {
                const url = response.results.object.url;
                setAvatar(url);
                const dataEdit = {
                    avatar: url,
                };
                dispatch(
                    updateInfoProfile(
                        dataEdit,
                        (isSuccess) => {
                            if (isSuccess) {
                                notification.open({
                                    message: 'Image changed successfully',
                                    duration: 2,
                                    placement: 'top',
                                });
                            } else {
                            }
                        },
                        (err) => {
                            if (err.message) {
                                notification.open({
                                    message: err.message,
                                    duration: 2,
                                    placement: 'top',
                                });
                            }
                        },
                    ),
                );
            }
        } catch (err) {
            console.log('🚀 ~ file: index.js ~ line 56 ~ handleUpload ~ error', err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangChinhSuaHoSo');
        // eslint-disable-next-line
    }, []);
    return (
        <>
            {' '}
            {/* pc */}
            <div className={cx('wrapper')}>
                <div className={cx('container')}>
                    <div className={cx('left_section')}>
                        <div className={cx('left_wrapper')}>
                            <div className={cx('left_container')}>
                                <Row>
                                    <CardAboutMe tabIndex={{ parent: 0, children: 0 }} />
                                </Row>
                            </div>
                        </div>
                    </div>
                    <div className={cx('title_header')}>
                        <Row className={cx('title_header_row')}>
                            <p className={cx('title')}>
                                <LeftOutlined onClick={() => navigate(-1)} className={cx('btn_back')} /> Edit information
                                personal message
                            </p>
                        </Row>
                    </div>
                    <div className={cx('right_section')}>
                        <div className={cx('right_container')}>
                            <Row align="middle" style={{ height: '550px' }}>
                                <Col xs={16} className={cx('left_content')}>
                                    <div className={cx('form_container')}>
                                        <Row justify="center">
                                            <div className={cx('title_page')}>Personal information</div>
                                        </Row>
                                        <Row justify="center">
                                            <div className={cx('sub_title_page')}>
                                                Manage profile information for account security
                                            </div>
                                        </Row>
                                        {msgError && (
                                            <Row justify="center" className={cx('err')}>
                                                {msgError}
                                            </Row>
                                        )}
                                        <Row justify="center">
                                            <Form onFinish={onFinishEdit} form={form} style={{ width: '100%' }}>
                                                <Row>
                                                    <Form.Item
                                                        name="fullname"
                                                        rules={[{ max: 50, message: 'Maximum name 50 characters' }]}
                                                        style={{ width: '100%', margin: '10px' }}
                                                    >
                                                        <Input placeholder="Name" className={cx('item_input')} />
                                                    </Form.Item>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                                                        <Form.Item style={{ margin: '10px' }}>
                                                            <Birthday>
                                                                <DatePicker
                                                                    placeholder="Birth date"
                                                                    onChange={(_, value) => handleChangeBirthday(value)}
                                                                    defaultValue={
                                                                        birthday ? moment(birthday, 'YYYY-MM-DD') : null
                                                                    }
                                                                    format="YYYY-MM-DD"
                                                                    inputReadOnly={true}
                                                                />
                                                            </Birthday>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Form.Item style={{ margin: '10px' }}>
                                                            <Gender>
                                                                <Select
                                                                    placeholder="Gender"
                                                                    className={cx('item_input')}
                                                                    value={gender}
                                                                    onChange={(value) => handleChangeGender(value)}
                                                                >
                                                                    {genderList?.map((item) => {
                                                                        return (
                                                                            <Select.Option
                                                                                value={item?.value}
                                                                                key={item?.value}
                                                                            >
                                                                                {item?.title}
                                                                            </Select.Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </Gender>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            name="email"
                                                            rules={[
                                                                { type: 'email', message: 'Incorrect email address' },
                                                            ]}
                                                            style={{ margin: '10px' }}
                                                        >
                                                            <Input placeholder="Email" className={cx('item_input')} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            name="phone"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please enter phone number',
                                                                },
                                                                {
                                                                    // pattern: new RegExp(/^[0-9\S]*$/),
                                                                    pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                                                                    message: 'Wrong phone number format',
                                                                },
                                                                { min: 10, message: 'Phone number must have 10 digits' },
                                                            ]}
                                                            style={{ margin: '10px' }}
                                                        >
                                                            <Input
                                                                placeholder="Phone number"
                                                                onKeyDown={checkKeyDownNumberInput}
                                                                maxLength={10}
                                                                className={cx('item_input')}
                                                                disabled={true}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row justify="center">
                                                    <button htmlType="submit" className={cx('btn_edit')}>
                                                        Save information
                                                    </button>
                                                </Row>
                                            </Form>
                                        </Row>
                                    </div>
                                </Col>
                                <Col xs={8} className={cx('right_content')}>
                                    <div className={cx('content')}>
                                        <Row className={cx('avatar')}>
                                            <img src={avatar ? avatar : IMAGES.ImagePlaceholder} alt="" />
                                        </Row>
                                        <Row>
                                            <label htmlFor="contained-button-file">
                                                <ChangeAVT>
                                                    <Input
                                                        onChange={(e) => {
                                                            handleUpload(e);
                                                        }}
                                                        accept="image/*"
                                                        id="contained-button-file"
                                                        multiple
                                                        type="file"
                                                    />
                                                    <div className={cx('btn_change_img')}>Change image</div>
                                                </ChangeAVT>
                                            </label>
                                        </Row>
                                        <Row>
                                            <div className={cx('noti')}>
                                                <div>Maximum file size 1 MB</div>
                                                <div>Format:.JPEG, .PNG</div>
                                            </div>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
            {/* mobile */}
            <div className={cx('wrapper_mb')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 0, children: 0 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined onClick={() => navigate(-1)} className={cx('btn_back')} /> Update information
                        </p>
                    </Row>
                </div>
                <div className={cx('form_container')}>
                    <div className={cx('change_avata')}>
                        <Row justify="center">
                            <img src={avatar ? avatar : IMAGES.ImagePlaceholder} alt="" className={cx('avatar')} />
                        </Row>
                        <Row justify="center">
                            <div>
                                <label htmlFor="contained-button-file">
                                    <ChangeAVT>
                                        <Input
                                            onChange={(e) => {
                                                handleUpload(e);
                                            }}
                                            accept="image/*"
                                            id="contained-button-file"
                                            multiple
                                            type="file"
                                        />

                                        <div className={cx('btn_change_avata')}>
                                            <img src={SVGS.IconCameraWhite} alt="" />
                                        </div>
                                    </ChangeAVT>
                                </label>
                            </div>
                        </Row>
                    </div>

                    {msgError && (
                        <Row justify="center" className={cx('err')}>
                            {msgError}
                        </Row>
                    )}
                    <Row justify="center">
                        <Form onFinish={onFinishEdit} form={form} style={{ width: '100%' }}>
                            <Row>
                                <Form.Item
                                    name="fullname"
                                    rules={[{ max: 50, message: 'Maximum name 50 characters' }]}
                                    style={{ width: '100%', margin: '10px' }}
                                >
                                    <Input placeholder="Name" className={cx('item_input')} />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Item style={{ margin: '10px' }}>
                                        <Birthday>
                                            <DatePicker
                                                placeholder="Birth date"
                                                onChange={(_, value) => handleChangeBirthday(value)}
                                                defaultValue={birthday ? moment(birthday, 'YYYY-MM-DD') : null}
                                                format="YYYY-MM-DD"
                                                inputReadOnly={true}
                                            />
                                        </Birthday>
                                    </Form.Item>
                                </Col>
                                <Col xs={12}>
                                    <Form.Item style={{ margin: '10px' }}>
                                        <Gender>
                                            <Select
                                                placeholder="Gender"
                                                className={cx('item_input')}
                                                value={gender}
                                                onChange={(value) => handleChangeGender(value)}
                                            >
                                                {genderList?.map((item) => {
                                                    return (
                                                        <Select.Option value={item?.value} key={item?.value}>
                                                            {item?.title}
                                                        </Select.Option>
                                                    );
                                                })}
                                            </Select>
                                        </Gender>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Item
                                        name="email"
                                        rules={[{ type: 'email', message: 'Incorrect email address' }]}
                                        style={{ margin: '10px' }}
                                    >
                                        <Input placeholder="Email" className={cx('item_input')} />
                                    </Form.Item>
                                </Col>
                                <Col xs={12}>
                                    <Form.Item
                                        name="phone"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter phone number',
                                            },
                                            {
                                                // pattern: new RegExp(/^[0-9\S]*$/),
                                                pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                                                message: 'Wrong phone number format',
                                            },
                                            { min: 10, message: 'Phone number must have 10 digits' },
                                        ]}
                                        style={{ margin: '10px' }}
                                    >
                                        <Input
                                            placeholder="Phone number"
                                            onKeyDown={checkKeyDownNumberInput}
                                            maxLength={10}
                                            className={cx('item_input')}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row justify="center">
                                <button htmlType="submit" className={cx('btn_edit')}>
                                    Save information
                                </button>
                            </Row>
                        </Form>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default EditProfile;
